import React from 'react';
import { Button } from '../../../ui/Button';
import { useClientFormContext } from '../contexts/ClientFormContext';

interface MatchingProps {
  onSave: (formData: any) => void;
}

export const Matching: React.FC<MatchingProps> = ({ onSave }) => {
  const { formData } = useClientFormContext();

  const handleSave = () => {
    console.log('💾 Matching - handleSave appelé avec formData:', formData);
    onSave(formData);
  };

  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-gray-50 p-6 dark:bg-gray-800">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
          Résumé du client
        </h3>
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Nom :</strong> {formData.civility} {formData.firstName} {formData.lastName}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Téléphone :</strong> {formData.phone}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Email :</strong> {formData.email}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Adresse :</strong> {formData.address}, {formData.city}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Type de transaction :</strong> {formData.transactionType === 'sale' ? 'Achat' : formData.transactionType === 'rent' ? 'Location' : 'Location courte durée'}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Type de bien :</strong> {formData.propertyType}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Budget :</strong> {formData.minBudget} - {formData.maxBudget} DA
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              <strong>Critères :</strong> {Object.keys(formData.criteria || {}).filter(key => formData.criteria[key]).length} critère(s) sélectionné(s)
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <Button onClick={handleSave}>
          Enregistrer
        </Button>
      </div>
    </div>
  );
};